module.exports = __webpack_public_path__ + "static/media/autokar (8).b32d0193.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/wynajem/autokar (8).jpg
// module id = 846
// module chunks = 0